<template>
  <div class="order-list-wrap">
    <!-- 引入公共头部 -->
    <dg-header :showBack="true" title="订单列表" ></dg-header>
    <order-tabbar></order-tabbar>
  </div>
</template>
<script>
import DgHeader from '@/components/header'
import OrderTabbar from './components/tab'

export default {
  data () {
    return {
      
    }
  },
  components: {
    DgHeader,
    OrderTabbar,
  }
}
</script>
<style lang="scss" scoped>
.order-list-wrap{
  padding-top: 88px; 
  .header-wrap{
    // position: fixed;
    // top: 0;
    // z-index: 9;
  }
}
</style>

